import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselIndicators from '../shared/CarouselIndicators.vue';
import DxpCarouselProductCard from 'JS/dxp/components/shared/DxpCarouselProductCard.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { CarouselType } from 'JS/types/Carousel';
import { getPriceMode } from 'JS/types/Product';
import { ListSliderElement, SlideChangeEvent } from 'JS/list-slider';
import { onMounted, ref } from 'vue';
import { TrendingCarouselWidgetResource } from 'JS/dxp/types/widgets/trending-carousel-widget';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingCarouselWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: TrendingCarouselWidgetResource;
}



const slider = ref<ListSliderElement>();
const numSlides = ref(0);
const currentSlide = ref(0);

onMounted(() => {
	// We need to set up our carousel on load to populate our indicators
	numSlides.value = slider.value?.slideCount ?? 0;
	currentSlide.value = slider.value?.slide ?? 0;
});

function handleSlideChange(e: SlideChangeEvent) {
	const { toSlide, slideCount } = e.detail;
	currentSlide.value = toSlide;
	numSlides.value = slideCount;
}

function handleUpdateSlide(slide: number) {
	if (slider.value) {
		slider.value.slide = slide;
	}
}

///////GA Tracking///////
const intersectionObserverOptions = {
	root: null,
	rootMargin: '-150px', //Trigger once 150px of the carousel is in view
};

const { trackView, trackClick } = useProductCarouselTracking(() => ({
	type: CarouselType.TRENDING,
	name: "DXP Trending Carousel",
	products: props.widget.data.products.map(product => ({
		blainNumber: product.blainNumber,
		vendorBrand: product.brand,
		productName: product.name,
		price: product.price,
		belowMap: product.price.isBelowMAP,
		priceMode: getPriceMode(product.price)
	}))
}));


return { __sfc: true,props, slider, numSlides, currentSlide, handleSlideChange, handleUpdateSlide, intersectionObserverOptions, trackView, trackClick, CarouselArrowButton, CarouselIndicators, DxpCarouselProductCard, VIntersectionObserver }
}

})